import { render, staticRenderFns } from "./ScheduleTemplateItemOnAirDate.vue?vue&type=template&id=4d5c0ea6&scoped=true&"
import script from "./ScheduleTemplateItemOnAirDate.vue?vue&type=script&lang=js&"
export * from "./ScheduleTemplateItemOnAirDate.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleTemplateItemOnAirDate.vue?vue&type=style&index=0&id=4d5c0ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c0ea6",
  null
  
)

export default component.exports